import { render, staticRenderFns } from "./accordionItem.vue?vue&type=template&id=1362d748&scoped=true"
import script from "./accordionItem.vue?vue&type=script&lang=js"
export * from "./accordionItem.vue?vue&type=script&lang=js"
import style0 from "./accordionItem.vue?vue&type=style&index=0&id=1362d748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362d748",
  null
  
)

export default component.exports